import { put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import { loadSuccess, loadFailure } from "./actions";
import { apiV2 } from "../../../services/axios";
import { CheckinReleaseTypes, CheckinReleasePayload } from "./types";
import { takeLatest } from "redux-saga/effects";

interface IPayloadCheckinRelease {
  type: typeof CheckinReleaseTypes.LOAD_REQUEST;
  payload: {
    limit: number;
    page: number;
  };
}

export function* getCheckinRelease({ payload }: IPayloadCheckinRelease) {

  try {
    // const data = [
    //   { id: "1", attendance: "ATD-10234", patientName: "João da Silva", origin: "123654", checkInDate: "17/12/2025 08:42" },
    //   { id: "2", attendance: "ATD-10235", patientName: "Maria de Souza", origin: "135233", checkInDate: "17/12/2025 09:05" },
    //   { id: "3", attendance: "ATD-10236", patientName: "Carlos Lima", origin: "123444", checkInDate: "17/12/2025 09:18" },
    //   { id: "4", attendance: "ATD-10237", patientName: "Ana Santos", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "5", attendance: "ATD-10238", patientName: "Pedro Oliveira", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "6", attendance: "ATD-10239", patientName: "Ana Santos", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "7", attendance: "ATD-10240", patientName: "Pedro Oliveira", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "8", attendance: "ATD-10241", patientName: "Ana Santos", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "9", attendance: "ATD-10242", patientName: "Pedro Oliveira", origin: "123456", checkInDate: "17/12/2025 10:00" },
    //   { id: "10", attendance: "ATD-10243", patientName: "Ana Santos", origin: "123456", checkInDate: "17/12/2025 10:00" },
    // ];

    // Simula delay da API
    // yield call(() => new Promise((res) => setTimeout(res, 2000)));

    // Dispara sucesso com mock
    // yield put(loadSuccess(data));

    let response: AxiosResponse;
    response = yield call(
      apiV2.get as any,
      `/checkins/stuck?limit=${payload.limit ? payload.limit : 10}&page=${payload.page || 1}`
    );
    yield put(loadSuccess(response.data));
  } catch (error) {
    toast.error("Erro ao buscar informações do Checkin Release");
    yield put(loadFailure());
  }
}

interface IPayloadReleaseCheckin {
  type: typeof CheckinReleaseTypes.RELEASE_CHECKIN_REQUEST;
  payload: {
    id: string;
    observation: string;
  };
}

function* releaseCheckin({ payload }: IPayloadReleaseCheckin) {
  try {

    console.log("📤 Payload enviado para liberação:", payload);

    // yield call(() => new Promise((res) => setTimeout(res, 1000)));

    let response: AxiosResponse;
    response = yield call(
      apiV2.put as any,
      `/checkins/stuck/${payload.id}`
    );

    yield put({
      type: CheckinReleaseTypes.LOAD_REQUEST,
      payload: {
        id: 1
      }
    });

    toast.success("Check-in liberado com sucesso");
  } catch (error) {
    toast.error("Erro ao liberar o check-in");
  }
}

// function* releaseCheckin({ payload }: IPayloadReleaseCheckin) {
//   try {
//   yield call(api.patch, `/checkin/${payload.id}/release`, {
//     observation: payload.observation,
//   });

//     toast.success("Check-in liberado com sucesso");

//     yield put({
//       type: CheckinReleaseTypes.LOAD_REQUEST,
//       payload: { limit: 10, page: 1 },
//     });
//   } catch (error) {
//     toast.error("Erro ao liberar o check-in");
//   }
// }

export default function* checkinSaga() {
  yield takeLatest(
    CheckinReleaseTypes.LOAD_REQUEST,
    getCheckinRelease
  );

  yield takeLatest(
    CheckinReleaseTypes.RELEASE_CHECKIN_REQUEST,
    releaseCheckin
  );
}